import { Avatar, AvatarFallback } from "@/components/ui/avatar.tsx";
import { useGlobalStore } from "@/store/store.ts";
import { Menubar, MenubarContent, MenubarItem, MenubarMenu, MenubarTrigger } from "@/components/ui/menubar";
import AuthService from "@/services/auth";
import { envStorage } from "@/utils/envCache";
import { Button } from "@/components/ui/button";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import StepLoginDialog from "@/components//StepLoginDialog";
import { useState } from "react";
import setImg from "@/assets/home/set.png";
import outImg from "@/assets/home/out.png";
import add from "@/assets/search/add.png";
import SettingsDialog from "@/components/SettingsDialog";
import { MessageSquarePlus, PanelLeft } from 'lucide-react';
import eventBus from "@/utils/eventBus.ts";
import TitlleEidt from "@/assets/title-edit.svg?react";
import "./index.css";
import useCounterStore from "@/store";
import { HoverTip } from "@/components/hoverTip";
import { PlusIcon } from "@heroicons/react/16/solid";
import { Separator } from "@/components/ui/separator.tsx";
import SidebarSvg from "@/assets/home/sidebar.svg?react";
import { useTranslation } from "@/locales";
import { teamInfo } from "@/api/adminApi";
import { useIsMobile } from "@/hooks/use-mobile";

interface headerProps {
  title?: string;
  isShare?: boolean;
  onSelect?: () => void;
}

const Header = ({ title, isShare = false, onSelect }: headerProps) => {
  const { t } = useTranslation();
  const [loginOpen, setLoginOpen] = useState(false);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  // 控制弹窗显隐的状态
  const [dialogOpen, setDialogOpen] = useState(false);

  // 处理登录成功回调
  const handleLoginSuccess = (data: any) => {
    console.log("登录成功，数据：", data);
    // 这里的逻辑暂时在弹窗内做了
  };
  const openSet = () => {
    // 判断是否为移动端，移动端跳转设置页面，pc打开设置弹窗
    if (isMobile) {
      navigate("/settings");
    } else {
      setDialogOpen(true); // 打开密码修改弹窗
    }
  };
  const LaunchLogin = async () => {
    //退出登录
    AuthService.clearTokens();
    navigate("/", { replace: true });
    window.location.reload();
    return false;
    const res: any = await AuthService.logout();
    if (res) {
      navigate("/", { replace: true });
      window.location.reload();
      return null;
    }
  };
  const location = useLocation();
  // 当前路由的路径
  const currentPath = location.pathname;
  const [admin, setAdmin] = useState(false);
  const [adminFlag, setAdminFlag] = useState(null);
  const [isTitleShow, setIsTitleShow] = useState(false);
  const open = useCounterStore((state) => state.open);
  const pageOpen = useCounterStore((state) => state.pageOpen);

  useEffect(() => {
    //当前路由是否是管理后台
    if (currentPath.indexOf("/admin") !== -1) {
      setAdmin(true);
    }
  }, []);

  const handleSwitch = async () => {
    // localStorage.setItem('admin', 'true');
    // navigate("/admin/teamUser", { replace: true });
    const res: any = await teamInfo();
    if (res.type === "FULL_CONTROL") {
      envStorage.setItem("isFULL_CONTROL", "FULL_CONTROL");
    } else {
      envStorage.setItem("isFULL_CONTROL", "");
    }
    envStorage.setItem("adminRouterId", "teamUser");
    const host = window.location.href;
    if (!admin) {
      if (host.includes("https://beefin.tech/dev/")) {
        const url = `${window.location.origin}/dev/#/admin/teamUser`;
        window.open(url, "_blank");
      } else if (host.includes("https://beefin.tech/")) {
        const url = `${window.location.origin}/#/admin/teamUser`;
        window.open(url, "_blank");
      } else {
        const url = `${window.location.origin}/#/admin/teamUser`;
        window.open(url, "_blank");
      }
    }
  };

  const user = useGlobalStore((state) => state.user);
  const token = AuthService.getAccessToken();

  function handleMouseout() {
    setIsTitleShow(true);
  }

  function handleMouseLeave() {
    setIsTitleShow(false);
  }

  function editTitle() {
    eventBus.emit("editTitle");
  }

  const handleClick = () => {
    if (isMobile) {
      useCounterStore.getState().setMobileSidebarOpen(true);
    } else {
      useCounterStore.getState().setOpen(true);
      useCounterStore.getState().setPageOpen(true);
    }
  };

  function handleHome() {
    navigate("/", { replace: true });
    eventBus.emit("load");
  }

  useEffect(() => {
    const handleOpenLogin = () => {
      setLoginOpen(true);
    };

    // 添加事件监听器
    window.addEventListener("openLoginDialog", handleOpenLogin);

    // 清理事件监听器
    return () => {
      window.removeEventListener("openLoginDialog", handleOpenLogin);
    };
  }, []);

  // const info = AuthService.getUserInfo();
  return (
    <div>
      {!admin && (
        <div className="header h-15 md:h-16 items-center">
          {isMobile ? (!isShare && (
            <div className="flex items-center">
              <Button variant="ghost" size="icon" onClick={handleClick}>
                <PanelLeft className="w-3 h-5 text-[var(--text-text_primary)]" alt="" />
              </Button>
              {currentPath !== '/' && (
                <Button variant="ghost" size="icon" onClick={handleHome}>
                  <MessageSquarePlus className="w-5 h-5 text-[var(--text-text_primary)]" />
                </Button>
              )}
            </div>
          )) : (
            (!open || !pageOpen) && !isShare && (
              <div className={"flex items-center ml-1 mr-1 gap-1"}>
                <HoverTip position={"bottom"} content={t("chat.openSidebar")}>
                  <SidebarSvg className="ml-auto w-[18px] h-[18px]  text-[20px] cursor-pointer fill-[var(--text-text_primary)]" onClick={handleClick} alt="" />
                </HoverTip>
                <HoverTip position={"bottom"} content={t("chat.newChat")}>
                  <div className={"flex pr-[10px] pl-[8px] py-[6px] plus_add cursor-pointer"} onClick={handleHome}>
                    <PlusIcon className={"w-[20px] h-[20px]  text-[20px]"}></PlusIcon>
                    {t("chat.newChat")}
                  </div>
                </HoverTip>
                <div className={"h-[18px]"}>
                  <Separator orientation="vertical" />
                </div>
              </div>
            )
          )}
          {isShare ? (
            <div>
              <div className={"share_container"}>
                <div className={"share_chat"}>
                  <Button variant={"outline"}>
                    <div className={"share_chat_button"} onClick={onSelect}>
                      {t("share.selectAllMessages")}
                    </div>
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            title && (
              <div className="text-left  title text-[14px] font-medium text-[#09090B]" onMouseEnter={() => handleMouseout()} onMouseLeave={() => handleMouseLeave()}>
                <div className={"text-s-color-text-primary s-font-small-strong box-border"} onClick={editTitle}>
                  <div className="px-[4px] w-fit text-[var(--yb-md-h-color)] max-w-full flex items-center justify-start rounded-[4px] hover:bg-[var(--widget-opacity_primary)] cursor-pointer select-none hover:u-hover-show-parent-CigIit">
                    {title ?? ""}
                    {isTitleShow && <TitlleEidt className={"ml-[4px] text-[var(--yb-md-h-color)]"} style={{ width: "16px", height: "16px" }} />}
                  </div>
                </div>
                <div className="px-[4px] text-[10px] text-[#A6A6A6]">{t("common.ai_generated_content")}</div>
              </div>
            )
          )}

          {!token && !isMobile && (
            <div className="user">
              <Button size="sm" onClick={() => setLoginOpen(true)}>
                登录
              </Button>
            </div>
          )}

          {token && !isMobile && (
            <div className="user">
              {user ? (
                <Avatar>
                  <AvatarFallback style={{ backgroundColor: "#0169cc", color: "#fff" }}>
                    <span> {user.nickname.slice(0, 1)}</span>
                  </AvatarFallback>
                </Avatar>
              ) : (
                <Avatar></Avatar>
              )}

              <Menubar style={{ border: "none", boxShadow: "none" }}>
                <MenubarMenu>
                  <MenubarTrigger style={{ display: "block" }}>
                    <div>{user ? user.nickname : ""}</div>
                  </MenubarTrigger>
                  <MenubarContent className="min-w-[7rem]">
                    <MenubarItem onClick={() => openSet()}>
                      <img src={setImg} alt="" />
                      {t("common.settings")}
                    </MenubarItem>
                    <MenubarItem onClick={() => LaunchLogin()}>
                      <img src={outImg} alt="" />
                      {t("auth.logout")}
                    </MenubarItem>
                    {(user?.role === "ADMIN" || user?.role === "ROOT") && !isMobile && <div>{!admin && <MenubarItem onClick={() => handleSwitch()}>{t("admin.open_admin_panel")}</MenubarItem>}</div>}
                  </MenubarContent>
                </MenubarMenu>
              </Menubar>
            </div>
          )}
        </div>
      )}

      {admin && (
        <div className="header h-16" style={{ paddingLeft: "0" }}>
          {/*{admin&& (
                        <div
                            className='px-[4px] w-fit max-w-full flex items-center justify-start rounded-[4px] hover:bg-[var(--s-color-bg-trans)] cursor-pointer select-none hover:u-hover-show-parent-CigIit'>
                            {title ?? ''}
                        </div>
                    )}*/}

          {
            (!open || !pageOpen) && !isShare && (
              <div className={"flex items-center ml-1 mr-1 gap-1"}>
                <HoverTip position={"bottom"} content={t("chat.openSidebar")}>
                  <SidebarSvg className="ml-auto w-[18px] h-[18px]  text-[20px] cursor-pointer fill-[var(--text-text_primary)]" onClick={handleClick} alt="" />
                </HoverTip>
                <div className={"h-[18px]"}>
                  <Separator orientation="vertical" />
                </div>
              </div>
              )
          }
          {token && (
            <div className="user">
              {user ? (
                <Avatar>
                  <AvatarFallback style={{ backgroundColor: "#0169cc", color: "#fff" }}>
                    <span> {user.nickname.slice(0, 1)}</span>
                  </AvatarFallback>
                </Avatar>
              ) : (
                <Avatar></Avatar>
              )}

              <Menubar style={{ border: "none", boxShadow: "none" }}>
                <MenubarMenu>
                  <MenubarTrigger style={{ display: "block" }}>
                    <div>{user ? user.nickname : ""}</div>
                  </MenubarTrigger>
                  <MenubarContent className="min-w-[7rem]">
                    <MenubarItem onClick={() => openSet()}>
                      <img src={setImg} alt="" />
                      {t("common.settings")}
                    </MenubarItem>
                    <MenubarItem onClick={() => LaunchLogin()}>
                      <img src={outImg} alt="" />
                      {t("auth.logout")}
                    </MenubarItem>
                    <MenubarItem
                      onClick={() => {
                        window.location.href = "/";
                      }}
                    >
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{t("common.backToFrontend")}
                    </MenubarItem>
                  </MenubarContent>
                </MenubarMenu>
              </Menubar>
            </div>
          )}

          {/* 分步登录对话框 */}
          <StepLoginDialog isOpen={loginOpen} onOpenChange={setLoginOpen} onLoginSuccess={handleLoginSuccess} mode="dialog" />

          {/* 设置弹窗组件，通过 props 控制显隐 */}
          <SettingsDialog
            mode="dialog"
            isOpen={dialogOpen}
            onOpenChange={(open) => setDialogOpen(open)}
            defaultTab="general" // 可选：默认激活的标签页
          />
        </div>
      )}

      {/* 分步登录对话框 */}
      <StepLoginDialog isOpen={loginOpen} onOpenChange={setLoginOpen} onLoginSuccess={handleLoginSuccess} mode="dialog" />

      {/* 设置弹窗组件，通过 props 控制显隐 */}
      <SettingsDialog
        mode="dialog"
        isOpen={dialogOpen}
        onOpenChange={(open) => setDialogOpen(open)}
        defaultTab="general" // 可选：默认激活的标签页
      />
    </div>
  );
};

export default Header;
